const unhandledErrorSelector = (state: GlobalState) => state.unhandledError;
export const currentUnhandledErrorSelector = (state: GlobalState) => unhandledErrorSelector(state).current;
